export default class User {
    constructor(root) {
        this.root = root;

        this.form = this.root.querySelector('.js-user-form');
        this.reset_form = this.root.querySelector('.js-user-reset-form');
        this.form_status = this.root.querySelector('.js-user-form-status');

        if(this.form) {
            this.form_username = this.form.querySelector('.js-user-form-username');
            this.form_password = this.form.querySelector('.js-user-form-password');
            this.form_nonce = this.form.querySelector('#login-nonce');
            this.logout_button = this.root.querySelector('.js-user-logout');
        } else if(this.reset_form) {
            this.form_username = this.reset_form.querySelector('.js-user-reset-username');
            this.form_password = this.reset_form.querySelector('.js-user-reset-password');
            this.form_password_verify = this.reset_form.querySelector('.js-user-reset-password-verify');
            this.form_code = this.reset_form.querySelector('.js-user-reset-code');
            this.form_nonce = this.reset_form.querySelector('#login-nonce');
        }

        this.headshot_icon = document.querySelector('.js-user-headshot-icon');

        this.loading = this.root.querySelector('.js-user-loading');
        this.help_button = this.root.querySelector('.js-user-help-button');

        this.form?.addEventListener('submit', (e) => {
            e.preventDefault();

            if(this.validate()) {
                this.logIn();
            }
        });

        this.reset_form?.addEventListener('submit', (e) => {
            e.preventDefault();

            if(this.validate()) {
                this.reset();
            }
        });

        this.logout_button?.addEventListener('click', (e) => {
            e.preventDefault();
            this.logOut();
        });

        this.setupUserData();
    }

    validate() {
        let has_errors = false;

        if(this.form_username.value) {
            this.form_username.classList.remove('--error');
        } else {
            this.form_username.classList.add('--error');
            has_errors = true;
        }

        if(this.form_password.value) {
            this.form_password.classList.remove('--error');
        } else {
            this.form_password.classList.add('--error');
            has_errors = true;
        }

        if(this.form_password_verify) {
            if(this.form_password_verify.value && this.form_password.value == this.form_password_verify.value) {
                this.form_password_verify.classList.remove('--error');
            } else {
                this.form_password_verify.classList.add('--error');
                has_errors = true;
            }
        }

        return !has_errors;
    }

    logIn() {
        this.root.classList.add('--loading');
        this.loading?.classList.add('--active');

        jQuery.ajax({
            type: 'POST',
            dataType: 'json',
            url: window.theme.variables.ajax_url,
            data: {
                'action': 'ajax_login',
                'username': this.form_username.value,
                'password': this.form_password.value,
                'nonce': this.form_nonce.value
            },
            success: (data) => {
                if(data.logged_in == true) {
                    this.form_status.parentElement.classList.remove('--active');
                    this.form_status.parentElement.parentElement.classList.remove('--status-showing');

                    if(this.root.dataset.redirect == 'true') {
                        let url_params = new URLSearchParams(window.location.search);

                        if(url_params.get('url') != null) {
                            window.location.href = decodeURI(url_params.get('url'));
                        } else {
                            window.location.href = window.theme.variables.dashboard_url;
                        }
                    } else {
                        this.setupUserData();
                    }
                } else {
                    this.form_status.innerHTML = data.message;
                    this.form_status.parentElement.classList.add('--active');
                    this.form_status.parentElement.parentElement.classList.add('--status-showing');
                    this.root.classList.remove('--loading');
                    this.loading?.classList.remove('--active');
                    this.help_button.parentElement.classList.remove('--hidden');
                }
            }
        });
    }

    reset() {
        this.root.classList.add('--loading');
        this.loading?.classList.add('--active');

        jQuery.ajax({
            type: 'POST',
            dataType: 'json',
            url: window.theme.variables.ajax_url,
            data: {
                'action': 'reset_user_password',
                'username': this.form_username.value,
                'code': this.form_code.value,
                'nonce': this.form_nonce.value,
                'password': this.form_password.value,
                'password_verify': this.form_password_verify.value,
            },
            success: (data) => {
                if(data.reset == true) {
                    this.form_status.parentElement.classList.remove('--active');
                    this.form_status.parentElement.parentElement.classList.remove('--status-showing');
                    window.location.href = window.theme.variables.login_url;
                } else {
                    this.form_status.innerHTML = data.message;
                    this.form_status.parentElement.classList.add('--active');
                    this.form_status.parentElement.parentElement.classList.add('--status-showing');
                    this.root.classList.remove('--loading');
                    this.loading?.classList.remove('--active');
                    this.help_button?.parentElement.classList.remove('--hidden');
                }
            }
        });
    }

    setupUserData() {
        jQuery.ajax({
            type: 'GET',
            dataType: 'json',
            url: window.theme.variables.ajax_url,
            data: {
                'action': 'get_user_data',
            },
            success: (data) => {
                setTimeout(() => {
                    if(JSON.stringify(data) != '{}') {
                        this.root.classList.add('--user-logged-in');

                        //output user data to entire window
                        window.current_user = data;
                        window.dispatchEvent(new Event('user-data-received'));
                    } else {
                        this.root.classList.remove('--user-logged-in');
                    }

                    if(data.name) {
                        let first_name_fields = document.querySelectorAll('.js-user-first-name');
                        let last_name_fields = document.querySelectorAll('.js-user-last-name');
                        let full_name_fields = document.querySelectorAll('.js-user-full-name');

                        first_name_fields.forEach((first_name_field) => {
                            first_name_field.innerHTML = data.name.first;
                        });

                        last_name_fields.forEach((last_name_field) => {
                            last_name_field.innerHTML = data.name.last;
                        });

                        full_name_fields.forEach((full_name_field) => {
                            full_name_field.innerHTML = data.name.full;
                        });
                    }

                    if(data.role) {
                        let role_fields = document.querySelectorAll('.js-user-roles');

                        role_fields.forEach((role_field) => {
                            if(data.aaf_member == true && data.role == 'AAF User') {
                                role_field.innerHTML = data.membership_type;
                            } else {
                                role_field.innerHTML = data.role;
                            }
                        });
                    }

                    if(data.pronouns) {
                        let pronoun_fields = document.querySelectorAll('.js-user-pronouns');

                        pronoun_fields.forEach((pronoun_field) => {
                            pronoun_field.innerHTML = data.pronouns;
                        });
                    }

                    if(data.professional_title) {
                        let title_fields = document.querySelectorAll('.js-user-title');

                        title_fields.forEach((title_field) => {
                            title_field.innerHTML = data.professional_title;
                        });
                    }

                    if(data.company) {
                        let company_fields = document.querySelectorAll('.js-user-company');

                        company_fields.forEach((company_field) => {
                            company_field.innerHTML = data.company;
                        });
                    }

                    if(data.cell_phone) {
                        let phone_fields = document.querySelectorAll('.js-user-phone');

                        phone_fields.forEach((phone_field) => {
                            phone_field.innerHTML = data.cell_phone;
                        });
                    }

                    if(data.email) {
                        let email_fields = document.querySelectorAll('.js-user-phone');

                        email_fields.forEach((email_field) => {
                            email_field.innerHTML = data.email;
                        });
                    }

                    if(data.headshot) {
                        let headshot_images = document.querySelectorAll('.js-user-headshot');

                        headshot_images.forEach((headshot_image) => {
                            headshot_image.setAttribute('src', data.headshot);

                            if(data.name && data.name.full) {
                                headshot_image.setAttribute('alt', data.name.full);
                            }
                        });

                        this.headshot_icon?.classList.add('--active');
                    }

                    if(data.wp_admin && data.wp_admin == true) {
                        let admin_links = document.querySelectorAll('.js-user-admin-link');

                        admin_links.forEach((admin_link) => {
                            admin_link.classList.remove('--hidden');
                        });
                    }

                    this.root.classList.remove('--loading');
                    this.loading?.classList.remove('--active');
                }, 1500);
            }
        });
    }

    logOut() {
        this.root.classList.add('--loading');
        this.loading?.classList.add('--active');

        jQuery.ajax({
            type: 'POST',
            url: window.theme.variables.ajax_url,
            data: {
                'action': 'ajax_logout',
                'nonce': window.theme.nonces.ajax_logout_nonce
            },
            success: (data) => {
                setTimeout(() => {
                    this.root.classList.remove('--user-logged-in');

                    this.form_status.innerHTML = 'You have been logged out.';
                    this.form_status.parentElement.classList.add('--active');
                    this.form_status.parentElement.parentElement.classList.add('--status-showing');
                    this.root.classList.remove('--loading');
                    this.loading?.classList.remove('--active');
                    this.headshot_icon.classList.remove('--active');

                    window.current_user = null;
                    window.dispatchEvent(new Event('user-data-removed'));

                    setTimeout(() => {
                        this.form_status.parentElement.classList.remove('--active');
                        this.form_status.parentElement.parentElement.classList.remove('--status-showing');
                    }, 2000);
                }, 1500);
            }
        });
    }
}
